import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Stack, Typography, Card, CardHeader, CardContent, Checkbox, TextField } from '@mui/material';
import { GridToolbar, plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';

import { formatDateTime } from '../../../../../../services/functions';

const Noitfications = ({ formik }) => {
  const { order } = useSelector(state => state.app);
  const [trescPowiadomienia, setTrescPowiadomienia] = React.useState('');

  const columns = [
    { field: 'created_at', headerName: 'Data', flex: 0.4, valueGetter: params => formatDateTime(params.row.created_at) },
    { field: 'pl_type_name', headerName: 'Typ Powiadomienia', flex: 0.8 },
    { field: 'addressee', headerName: 'Adresat', flex: 0.4 },
    { field: 'title', headerName: 'Tytuł Powiadomienia', flex: 0.8 },
    { field: 'message', headerName: 'Wycinek Treści', flex: 1.2 },
    { field: 'sender', headerName: 'Użytkownik', flex: 0.4 }
  ];

  return (
    <Card>
      <CardHeader title="Powiadomienia"></CardHeader>
      <CardContent >
        <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'row' }}>
          <Stack direction="column" justifyContent="space-between">
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
              <Checkbox id="automatic_notifications" name="automatic_notifications" checked={formik.values.automatic_notifications} onChange={formik.handleChange}/>
              <Typography variant="subtitle2">Powiadomienia automatyczne</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
              <Checkbox id="manual_notifications" name="manual_notifications" checked={formik.values.manual_notifications} onChange={formik.handleChange} />
              <Typography variant="subtitle2">Powiadomienia ręczne</Typography>
            </Stack>
          </Stack>
          <Stack direction="column" justifyContent="space-between" flex="1 1 50%" spacing={4}>
            <TextField
              id="tresc-powiadomienia"
              label="Treść powiadomienia"
              multiline
              placeholder="Wybierz powiadomienie"
              disabled
              value={trescPowiadomienia}
              maxRows={5}
            />
          </Stack>
        </form>
        <Box height={40}/>
        <DataGridPro
          autoHeight
          rows={order.notifications}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 25]}
          onRowClick={params => setTrescPowiadomienia(params.row.message)}
          pagination
          components={{ Toolbar: GridToolbar }}
          localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
        />
      </CardContent>
    </Card>

  );
};


export default Noitfications;
